import React from "react";
import {CarzelleTooltip} from "../System/Messages/CarzelleTooltip";

export const VATIcon = React.memo(({vatStatusId}) => {
    return (
        <CarzelleTooltip message="I = VAT Included/Margin | E = VAT Excluded/Net">
            <span className='text-xs flex items-center text-black justify-center rounded-full w-5 h-5 font-bold bg-slate-200'>{vatStatusId === 4 ? 'I' : 'E'}</span>
        </CarzelleTooltip>
    )
});